import { AxiosError } from "axios";

import { ICustomerTemplate } from "@/interfaces/customer-template.interface";
import { apiT2B } from "@/lib/axios";

import { normalizeCustomerTemplate } from "./filter-customer-templates";

const baseUrl = "/api/v1/CustomerTemplate";

export async function getCustomerTemplateById(id: number): Promise<ICustomerTemplate> {
  try {
    const response = await apiT2B.get(`${baseUrl}/${id}`);
    const raw = (response.data?.data ?? response.data) as Record<string, unknown>;
    const template = normalizeCustomerTemplate(raw);

    if (!template) throw new Error("Template não encontrado");

    return template;
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Falha ao carregar o template");
    }

    throw error instanceof Error ? error : new Error("Falha ao carregar o template");
  }
}
